import React from 'react';

export default function Display({type, size, styles, text, children}) {
  return (
    <div className={`${styles} display display__${type} display__${size}`}>
      {text || children}
    </div>
  )
}
